import React from 'react';
import { Icon } from './Icon.js';
export const IconRectCenterXFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M2.75,2c-.414,0-.75,.336-.75,.75V15.25c0,.414,.336,.75,.75,.75s.75-.336,.75-.75V2.75c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.25,2c-.414,0-.75,.336-.75,.75V15.25c0,.414,.336,.75,.75,.75s.75-.336,.75-.75V2.75c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "5", y: "5", width: "8", height: "8", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectCenterXFill18.js.map